// extracted by mini-css-extract-plugin
export default {"wrapper":"hk","form":"ik","preference":"jk","request":"kk","job":"lk","smallprint":"mk","asterisk":"nk","success":"ok","circle":"pk"};